<template>
  <li tabindex="-1" :data-playing="isPlaying">
    <a href="#" :tabindex="tabindex"  @click.prevent="click" :title="attachment.description">
      <t-icon name="icon-sound" /> {{ attachment.name }} <span class="muted">({{ duration(attachment.duration) }})</span>
    </a>
  </li>
</template>

<script>
import EventBus from '@/utils/eventBus'
import moment from 'moment'
import { assetApi } from 'api'
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      sources: []
    }
  },
  mounted () {
    this.sources = [ assetApi.getStreamUrl(this.attachment.assetUrlPath) ]
  },
  methods: {
    ...mapActions('audio', ['setSelected']),
    duration (durationString) {
      return moment(moment.duration(durationString).asMilliseconds()).format('mm:ss')
    },
    click () {
      if (this.pageNumber) {
        this.$router.push({ name: 'Page', params: { pageNumber: this.pageNumber } })
      }
      if (this.isPlaying) {
        EventBus.$emit('stop')
      } else {
        if (this.selectedAudio === null || this.selectedAudio.assetId !== this.attachment.assetId) {
          this.setSelected(this.attachment)
        }
        this.$nextTick(() => EventBus.$emit('play'))
      }
    }
  },
  computed: {
    ...mapGetters('audio', { selectedAudio: 'selected', playerPlaying: 'playing' }),
    isPlaying () {
      return this.selectedAudio !== null && this.selectedAudio.assetId === this.attachment.assetId && this.playerPlaying
    }
  },
  props: {
    attachment: {
      type: Object,
      required: true
    },
    pageNumber: {
      type: Number
    },
    tabindex: {
      type: Number,
      default () {
        return -1
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/misc/AudioListItem.vue